import React from 'react';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import PageHero from '../Elements/PageHero';
import AboutIndustrialMechanical from '../Elements/AboutIndustrialMechanical';
import CtaBand from '../Elements/CtaBand';
import Contact from '../Elements/Contact';
import useReveal from '../../hooks/useReveal';
import usePageMeta from '../../hooks/usePageMeta';
import { industrialMechanical as data } from '../../content/site';

const ServicesIndustrialMechanical = () => {
  useReveal();
  usePageMeta({
    title: `${data.title} | LIDA Engineering`,
    description: data.lead,
  });

  return (
    <>
      <Header overHero />
      <main id="main" className="page-content">
        <PageHero
          eyebrow={data.eyebrow}
          title={data.title}
          lead={data.lead}
          image={data.heroImage}
          imageAlt="Scaffolded facade on a LIDA Engineering industrial project"
        />
        <AboutIndustrialMechanical />
        <CtaBand />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

export default ServicesIndustrialMechanical;
